<div ng-controller="modulesController as ctrl">
        <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
</div>